//@ts-check
import React from 'react';
import Text from './Text';

var DescriptionField = function DescriptionField(props) {
  return React.createElement(Text, Object.assign({
    multiline: true,
    rows: "2",
    rowsMax: "4"
  }, props));
};

export default DescriptionField;